<template>
  <div class="line-invite">
    <div class="invite-flex">
      <h1 class="invite-title">为美好生活充电</h1>
      <div class="small-title">{{operData.oprName}}</div>
    </div>
      <div class="line-info">
        <p class="p-text">将链接分享给好友，点击进行注册。60分钟内有效</p>
        <div class="line-text text-hide">{{url}}</div>
        <div class="bgn-box">
          <pi-button type="primary" block @click="copy">复制地址</pi-button>
        </div>
      </div>
  </div>
</template>
<script>
import { getOperInfo } from '../../common/api';
import { mapState } from "vuex";
export default {
  name: 'line-invite',
  data(){
    return{
      operData: {},
      url: '',
      oprPkId: ''
    }
  },
  computed: {
    ...mapState(["app"]),
  },
  methods: {
    copy(){
      this.$common.copyText(this.url,()=>{
        this.$toast("复制成功");
      })
    },
    getOperInfo(){
      getOperInfo({oprPkId: this.$common.get("oprPkId")}).then(data => {
        if (data.status === this.$config.ajaxStatus) {
          this.operData = data.data[0];
        }
      })
    }
  },
  mounted() {
    this.oprPkId = this.$common.get("oprPkId");
    this.url = window.location.origin + '/#/?oprPkId='+ this.oprPkId+'&inviter='+this.app.userInfo.userPkId;
    this.getOperInfo();
  }
}
</script>
<style lang="less">
  .line-invite{
    height: 100%;
    background-image: url('../../assets/image/invite-box-bg.png');
    background-size:100%;
    display: flex;
    flex-direction: column;
    .invite-flex{
      flex:1;
    }
    .invite-title{
      padding-top: 0.75rem;
      font-size: 0.7rem;
      line-height: 0.98rem;
      text-align: center;
      color: #14CC80;
    }
    .small-title{
      text-align: center;
      color: #22863B;
      font-size: 0.28rem;
      line-height: 0.4rem;
    }
    .line-info{
      background-color: #fff;
      border-radius: 0.3rem 0.3rem 0px 0px;
      box-sizing: border-box;
      padding: 0.76rem 0.4rem 0.4rem 0.4rem;
      .p-text{
        text-align: center;
        color: #666;
        font-size: 0.28rem;
        line-height: 0.4rem;
      }
      .line-text{
        height: 0.94rem;
        line-height: 0.94rem;
        padding: 0 0.2rem;
        color: #666666;
        background-color: #F5F5F5;
        border-radius: 0.07rem;
        margin-top: 0.6rem;
      }
      .bgn-box{
        margin-top: 1.19rem;
        .mg{
          margin-top: 0.3rem;
        }
      }
    }
  }
</style>